import React from 'react';
import Card from '@material-ui/core/Card';
import photo2 from '../images/photo2.jpg';

/**
 * This function renders the Office of the CEO page
 * @component OfficePage
 * @return {Component} OfficePage component
 */
export default function OfficePage() {
  return (
    <Card
      style={{
        padding: '50px',
        width: '1200px',
        margin: '30px auto 30px auto',
      }}
    >
      <div style={{borderBottom: '1px solid silver', paddingBottom: '5px'}}>
        <h1>Office of the C.E.O.</h1>
      </div>
      <h2>Meet Jimmie David Ray, Junior</h2>
      <p>
        Jim D. Ray is an information scientist with decades of research
        experience in multiple concentrations. Ray has lectured on business
        finance at Valparaiso University in his home state of Indiana, and is
        also a 1997 graduate of the Northwest Indiana Entrepreneurship Academy.
        A vocal artist and former family comedy performer, Ray is also a former
        commercial real estate broker with pre- and post-9/11 market experience.
        Despite a steady focus on biodefense physics research between 2006 and
        2021, Ray achieved a 4.00 core-G.P.A. in a dual-major undergraduate
        program and earned twelve letters of personal reference and financial
        aid recommendation before abandoning traditional academics for
        accelerated professional enrichment. In 2022, Ray is introducing
        national biodefense initiatives that provide the United States
        Department of Defense critical details by dissecting adverse physics
        scenarios through his defense contracting enterprise, the Advanced
        Intelligence Services Corporation.
      </p>
      <h2>Ambitions</h2>
      <p>
        Next year, Ray intends to establish the American Institute of Metabolic
        Physics, a not-for-profit research organization designed to safely guide
        the international science community’s approach to the responsible
        development of metabolic physics information technologies in, and beyond
        the twenty-first century. This is a long-term, multi-circa research
        initiative assembling physicists, healthcare professionals, educators,
        intelligence analysts, law enforcement officials, lawmakers and lawyers,
        as well as defense industry vendors to participate in the progressive
        study of common trends in metabolic physics information technology
        hardware use in biodefense contexts within the science and industry
        communities.
      </p>
      <p>
        In physics, Ray seeks to forge alliances with industry engineers and
        manufacturers to impact the common quality and safety of metabolic
        physics technology hardware, and promote responsible use practices with
        information resources available through Advanced Intelligence Services.
      </p>
      <p>
        Ray’s primary bioscience goal is to become a first recipient-user of
        quasi-metabolic algorithmic modulation body rejuvenation therapy, a
        healthcare research topic Ray is expected to focus on until 2025.{' '}
      </p>
      <p>
        Over the next decade, Ray will explore national politics, having
        recently established a Presidential exploratory committee. His platform
        is available on social media and official web site at:
        www.jimrayusa.com.
      </p>
      <div style={{display: 'flex', flexDirection: 'column'}}>
        <div style={{alignSelf: 'center'}}>
          <iframe
            width="560"
            height="315"
            src="https://www.youtube.com/embed/NoKww8Y4CLk"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media;
            gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
          <br />
          <br />
          <br />
        </div>
        <img style={{margin: '0 auto'}} width="300px" src={photo2}></img>
      </div>
    </Card>
  );
}
